<script setup lang="ts">
import { arrayFrom, findElem, findElems, removeClass } from "../../Utils/helpers";
import { Dismiss }                                     from "flowbite";
import type { DismissInterface }                       from "flowbite";
import { onMounted, onUpdated }                        from "vue";

type TypeProps = {
    error? : string
};

defineProps<TypeProps>();

const dismiss = () : void => {
    const targetEls = <HTMLElement[] | []>arrayFrom(findElems('.alert-danger'));

    targetEls.forEach((alertEl : HTMLElement) : void => {
        const triggerEl = <HTMLElement | null>findElem('.alert-close-btn', alertEl);

        const dismiss : DismissInterface = new Dismiss(alertEl, triggerEl);

        dismiss.init();
    });
};

onMounted(() => {
    dismiss();
});

onUpdated(() => {
    dismiss();

    arrayFrom(findElems('.alert-danger'))
        .forEach((el : HTMLElement) : void | null => removeClass('hidden', el));
});
</script>

<template>
    <div v-if="error"
         class="flex items-start gap-3 max-w-lg p-4 mx-auto mb-4 text-sm text-red-800 border border-red-300
                rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400
                dark:border-red-800 alert-danger"
         role="alert">
        <svg class="flex-shrink-0 inline w-4 h-4 mt-1"
             aria-hidden="true"
             xmlns="http://www.w3.org/2000/svg"
             fill="currentColor"
             viewBox="0 0 20 20">
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
        </svg>

        <span class="sr-only">Info</span>

        <div>
            <span class="font-medium">{{ $page.props.text_danger_alert }}</span> {{ error }}
        </div>

        <button type="button"
                class="text-white bg-red-700 hover:bg-red-800 focus:ring-4
                       focus:ring-blue-300 font-medium rounded-lg text-sm
                       p-1 dark:bg-red-600 dark:hover:bg-red-700
                       focus:outline-none dark:focus:ring-red-800 alert-close-btn">

            <svg class="w-5 h-5 text-gray-800 dark:text-white"
                 aria-hidden="true"
                 xmlns="http://www.w3.org/2000/svg"
                 width="24"
                 height="24"
                 fill="none"
                 viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m15 9-6 6m0-6 6 6m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
            </svg>
        </button>
    </div>
</template>

<style scoped>

</style>
